import { getSyncQueue, removeFromSyncQueue } from './db';
import apiService from './api';

export const startSyncManager = () => {
  const syncOfflineActions = async () => {
    if (!navigator.onLine) return;
    
    try {
      const queue = await getSyncQueue();
      if (!queue || queue.length === 0) return;
      
      console.log(`SyncManager: Found ${queue.length} offline actions to sync.`);
      
      for (const item of queue) {
        try {
          if (item.action === 'CREATE_PURCHASE') {
            await apiService.createPurchase(item.data);
            await removeFromSyncQueue(item.id);
            console.log(`SyncManager: Synced CREATE_PURCHASE id: ${item.id}`);
          }
          else if (item.action === 'CREATE_SELL') {
            await apiService.saveSell(item.data);
            await removeFromSyncQueue(item.id);
            console.log(`SyncManager: Synced CREATE_SELL id: ${item.id}`);
          }
          else if (item.action === 'CREATE_PRODUCT') {
            await apiService.createProduct(item.data);
            await removeFromSyncQueue(item.id);
            console.log(`SyncManager: Synced CREATE_PRODUCT id: ${item.id}`);
          }
          else if (item.action === 'CREATE_CONTACT') {
            await apiService.createContact(item.data);
            await removeFromSyncQueue(item.id);
            console.log(`SyncManager: Synced CREATE_CONTACT id: ${item.id}`);
          }
          
        } catch (err) {
          console.error(`SyncManager: Failed to sync item ${item.id}`, err);
          // Optional: if it fails with 400 Bad Request, we might want to remove it to prevent endless loop
          // if (err.response && err.response.status === 400) { await removeFromSyncQueue(item.id); }
        }
      }
      
      // Optionally trigger a refresh of data once sync is complete
      window.dispatchEvent(new Event('etpos-sync-complete'));
    } catch (err) {
      console.error('SyncManager: Error running sync process', err);
    }
  };

  window.addEventListener('online', syncOfflineActions);
  
  // Try to sync on initial load if online
  if (navigator.onLine) {
    syncOfflineActions();
  }
};
